import Vue from 'vue'
import Vuetify from 'vuetify'
import i18n from '@/i18n'
import '@/sass/overrides.sass'

Vue.use(Vuetify)

const theme: {[key: string]: string} = {
  primary: '#00CAE3',
  success: '#00c237',
  secondary: '#9C27b0',
  accent: '#9C27b0',
  info: '#E91E63',
}

export default new Vuetify({
  lang: {
    t: (key: string, ...params: Array<string | number>) => i18n.t(key, params).toString(),
  },
  theme: {
    dark: true,
    themes: {
      dark: theme,
      light: theme,
    },
  },
})
